export default {
  httpHeaderContentTypeJSON: { 'Content-Type': 'application/json' },
  PUT: 'PUT',
  PATCH: 'PATCH',
  POST: 'POST',
  DELETE: 'DELETE',
  HTTP_METHOD_POST: 'POST',
  HTTP_METHOD_GET: 'GET',
  HTTP_METHOD_PATCH: 'PATCH',
  HTTP_STATUS_OK: 200,
  HTTP_STATUS_UNAUTH: 401,
};

export const HEADER_CONTENT_TYPE_JSON = {
  'Content-Type': 'application/json',
};

export const ASSIGN_VET_KEY = 'assignVetToProfile';
export const CLINIC_RESULT_WARNING_THRESHOLD = 50;
export const CLINIC_NAME_MAX_DISPLAY_LENGTH = 18;
export const CLINIC_NAME_MAX_ENTRY_LENGTH = 35;
export const CLINIC_NAME_MINIMUM = 3;
export const MOBILE_BREAKPOINT = 400;

export const queryKeyNewForm = 'new-form';
export const queryKeyNewFormNoRefresh = 'new-form-no-refresh';
